module.exports = {
  news: ({page = 1}, {language = 'de'}) =>
    `${language !== 'de' ? `/${language}` : ''}/blogs${page === 1 ? '' : `/${page}`}/`,
  kmagazin: ({page = 1}, {language = 'de'}) =>
    `${language !== 'de' ? `/${language}` : ''}/kmagazin${page === 1 ? '' : `/${page}`}/`,
}
